export const MainBodyCard = ({ children }) => {
    return (
        <div className="p-3 h-[calc(100vh-3.5rem)] overflow-hidden">
            <div className="w-full h-[calc(100vh-5rem)] bg-white sm:border rounded-xl sm:p-6 flex flex-col overflow-auto">
                { children }
            </div>
        </div>
    )
}